import React from 'react'
import LeavePolicyTable from './LeavePolicyTable'
export default function LeavePolicy() {
  return (
    <div>
      <LeavePolicyTable />
    </div>
  )
}
